import { render, staticRenderFns } from "./Core.vue?vue&type=template&id=05c63e5c"
import script from "./Core.vue?vue&type=script&lang=js"
export * from "./Core.vue?vue&type=script&lang=js"
import style0 from "./Core.vue?vue&type=style&index=0&id=05c63e5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports